<template>
  <div class="rating_view">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="120px"
      class="demo-ruleForm"
    >
      <el-form-item label="评分表名称：" prop="ratingName">
        <el-input v-model.trim="ruleForm.ratingName"></el-input>
      </el-form-item>
      <el-form-item label="评分表性质：" prop="property">
        <el-select v-model.trim="ruleForm.property" placeholder="请选择活动区域">
          <el-option label="一层级考核表" value="1"></el-option>
          <el-option label="二层级考核表" value="2"></el-option>
          <el-option label="三层级考核表" value="3"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ruleForm: {
        ratingName: "护理人员技术考核表", // 评分表名称
        property: "1", // 评分表性质
      },
      rules: {
        ratingName: [
          { required: true, message: "请输入评分表名称", trigger: "blur" },
        ],
        property: [
          { required: true, message: "请选择评分表性质", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    submitForm() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          //   alert("submit!");
          // this.$parent.parameter.title = this.ruleForm.ratingName;
          // this.$parent.parameter.property = this.ruleForm.property;
          this.$emit('ruleObj',this.ruleForm)
          this.$parent.active = 1;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.rating_view {
  display: flex;
  justify-content: center;
  align-items: center;
  .el-form {
    margin-top: 50px;
    width: 800px;
    .el-form-item {
      margin-bottom: 32px;
    }
    .el-input {
      width: 480px;
    }
    .el-select {
      width: 480px;
    }
  }
}
</style>